// Строка-тумблер раздела «Модели»: подпись слева, переключатель справа.
interface Props {
  label: string
  enabled: boolean
  onToggle: (on: boolean) => void
}

export function SwitchRow({ label, enabled, onToggle }: Props) {
  return (
    <div className="eyebrow flex items-center gap-1.5">
      {label}
      <button
        type="button"
        role="switch"
        aria-checked={enabled}
        aria-label={label}
        onClick={() => onToggle(!enabled)}
        className={
          'relative ml-auto h-4 w-7 rounded-full transition-colors ' +
          (enabled ? 'bg-sonar' : 'bg-hull')
        }
      >
        <span
          className="absolute top-0.5 h-3 w-3 rounded-full bg-white transition-all"
          style={{ left: enabled ? 14 : 2 }}
        />
      </button>
    </div>
  )
}
